import { useMemo } from 'react';
import { JSONSchema7 } from 'json-schema';
import { FieldMapping } from '../../../config/fieldMapping';
import { getSchemaObjectProperties } from '../formUtils';
import { generateUiSchema } from '../../../utils/generateUiSchema';

export const useFormSections = (jsonSchema: JSONSchema7, schemaMapping: Record<string, FieldMapping>) => {
    const sections = useMemo(() => getSchemaObjectProperties(jsonSchema), [jsonSchema]);
    const totalSections = 1 + sections.length;

    const generatedUiSchema = useMemo(() => {
        return generateUiSchema(jsonSchema, schemaMapping);
    }, [jsonSchema, schemaMapping]);

    return {
        sections,
        totalSections,
        generatedUiSchema
    }
}
